export default __webpack_public_path__ + "static/media/demo.06215606.jpg";